import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
    // position: 'relative'
  },
  entityName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.contrastText,
    borderRight: `1px solid ${theme.palette.grey[100]}`,
    background: theme.palette.grey[600],
    height: 68
    // position: 'sticky',
    // top: 0
  },
  accNameContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    background: theme.palette.grey[100],
    borderRight: `1px solid ${theme.palette.grey[900]}`
  },
  accNameContainerEven: {
    background: theme.palette.grey[300]
  },
  accName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  accName1680: {
    fontSize: '15px'
  },
  accName1440: {
    fontSize: '13px'
  },
  accName1280: {
    fontSize: '12px'
  }
}))

export default useStyles
